<script>
    import {axios, swal} from '../mixins';

    export default {
        name: 'DeleteConfirmation',

        mixins: [axios, swal],

        props: {
            url: {
                required: true,
                type: String,
            },
            name: {
                required: true,
                type: String,
            },
        },

        methods: {
            doDelete() {
                return this.swalConfirm('Confirm', `Please confirm the deletion of ${this.name}`).then((result) => {
                    if (result.value) {
                        this.swalLoading('', `Deleting ${this.name}...`);

                        this.post(this.url, {
                            '_method': 'DELETE',
                        }).then(() => {
                            this.swalClose();
                            this.swalSuccess('', `Successfully deleted ${this.name}`).finally(() => {
                                this.$emit('deleted', this.name);
                            });
                        }).catch(() => {
                            this.swalClose();
                            this.swalError('', `Failed to delete ${this.name}`);
                        });
                    }
                });
            },
        },
    };
</script>

<template>
    <button @click="doDelete">
        <slot></slot>
    </button>
</template>
